export default {
  promotions: (state: any) => state.promotions.data,
  promotion: (state: any) => state.promotion.data,
  materials: (state: any) => state.promotion.materials,
  promoCodes: (state: any) => state.promoCodes.data,
  // errors: (state: any) => state.errors,
};
